import { RegExpUtils } from '@shared/utils/regExp.utils';

export class SortUtils {
  static sortArrayByFieldGivenSpecialChars<T>(arr: T[], fieldName: keyof T): T[] {
    return [...arr].sort((a, b) => {
      const aValue = String(a[fieldName]);
      const bValue = String(b[fieldName]);

      const aFirst = aValue[0];
      const bFirst = bValue[0];
      const aIsSpecial = RegExpUtils.containsSpecialChar(aFirst);
      const bIsSpecial = RegExpUtils.containsSpecialChar(bFirst);

      if (aIsSpecial && bIsSpecial && aFirst === bFirst) {
        return aValue.localeCompare(bValue);
      }

      if (aIsSpecial && bIsSpecial) {
        return aFirst.localeCompare(bFirst);
      }

      if (aIsSpecial && !bIsSpecial) return -1;

      if (!aIsSpecial && bIsSpecial) return 1;

      return aValue.localeCompare(bValue);
    });
  }

  static sortArrayGivenSpecialChars(arr: string[]): string[] {
    return [...arr].sort((a, b) => {
      const aFirst = a[0];
      const bFirst = b[0];
      const aIsSpecial = RegExpUtils.containsSpecialChar(aFirst);
      const bIsSpecial = RegExpUtils.containsSpecialChar(bFirst);

      if (aIsSpecial && bIsSpecial && aFirst === bFirst) {
        return a.localeCompare(b);
      }

      if (aIsSpecial && bIsSpecial) {
        return aFirst.localeCompare(bFirst);
      }

      if (aIsSpecial && !bIsSpecial) return -1;

      if (!aIsSpecial && bIsSpecial) return 1;

      return a.localeCompare(b);
    });
  }
}
